if (!customElements.get("sq-product-accordion")) {
  class SQProductAccordion extends HTMLElement {
    constructor() {
      super();

      this.onVariantChanged = (event) => {
        this.updateAccordion(event);
      };
    }

    connectedCallback() {
      document.addEventListener(
        "variant:changed",
        this.onVariantChanged
      );

      this.updateAccordion();
    }

    disconnectedCallback() {
      document.removeEventListener(
        "variant:changed",
        this.onVariantChanged
      );
    }

    appendFormattedText(element, value) {
      const text = String(value);
      const pattern = /\*([^*]+)\*/g;
      let lastIndex = 0;
      let match;

      while ((match = pattern.exec(text)) !== null) {
        element.appendChild(
          document.createTextNode(
            text.slice(lastIndex, match.index)
          )
        );

        const strong = document.createElement("strong");
        strong.textContent = match[1];
        element.appendChild(strong);

        lastIndex = match.index + match[0].length;
      }

      element.appendChild(
        document.createTextNode(text.slice(lastIndex))
      );
    }

    getItems(value) {
      if (Array.isArray(value)) {
        return value.filter(item => typeof item === "string");
      }

      if (typeof value !== "string") return [];

      const text = value.trim();
      if (!text) return [];

      try {
        const parsed = JSON.parse(text);

        if (Array.isArray(parsed)) {
          return parsed.filter(
            item => typeof item === "string"
          );
        }
      } catch (error) {
        // 일반 문자열은 하나의 항목으로 표시합니다.
      }

      return [text];
    }

    renderList(container, items) {
      const list = document.createElement("ul");

      items.forEach(text => {
        const item = document.createElement("li");
        this.appendFormattedText(item, text);
        list.appendChild(item);
      });

      container.replaceChildren(list);
    }

    formatExistingContent(container) {
      const text = container.textContent.trim();
      if (!text.startsWith("[")) return;

      try {
        const items = JSON.parse(text);

        if (
          Array.isArray(items) &&
          items.every(item => typeof item === "string")
        ) {
          this.renderList(container, items);
        }
      } catch (error) {
        // 기존 HTML은 그대로 유지합니다.
      }
    }

    appendRow(container, labelText, value, attribute) {
      const list = container.querySelector("ul, ol");
      const row = document.createElement(list ? "li" : "p");
      row.setAttribute(attribute, "");

      const label = document.createElement("strong");
      label.textContent = labelText;
      row.appendChild(label);

      row.appendChild(
        document.createTextNode(" - " + value)
      );

      if (list) {
        list.appendChild(row);
      } else {
        const reference = container.querySelector("p");

        if (reference) {
          const style = window.getComputedStyle(reference);
          row.style.margin = style.margin;
          row.style.padding = style.padding;
          row.style.lineHeight = style.lineHeight;
        }

        container.appendChild(row);
      }
    }

    updateAccordion(event) {
      const dataElement = document.getElementById(
        "sq_accordion_data"
      );
      if (!dataElement) return;

      let accordionData;

      try {
        accordionData = JSON.parse(dataElement.textContent);
      } catch (error) {
        console.warn("Accordion data is not valid JSON.", error);
        return;
      }

      if (!Array.isArray(accordionData)) return;

      const eventVariant = event?.detail?.variant;
      const variantInput = document.getElementById(
        "sq-variant-id"
      );

      const variantId =
        eventVariant?.id ?? variantInput?.value;

      if (variantId == null) return;

      const variantData = accordionData.find(
        item => String(item.id) === String(variantId)
      );
      if (!variantData?.metafields) return;

      const metafields = variantData.metafields;

      const mapping = {
        "SIZE & MEASUREMENT": "size",
        "MATERIALS": "material",
        "COMPATIBILITY": "compatibility",
        "FEATURES": "feature"
      };

      // 이 아코디언 안의 블록만 수정합니다.
      const blocks = this.querySelectorAll(
        ".main-product__block-collapsible_tab"
      );

      blocks.forEach(block => {
        const container = block.querySelector(
          ".m-collapsible--content__inner"
        );
        if (!container) return;

        const title = (
          container.getAttribute("data-content-name") || ""
        ).trim().replace(/\s+/g, " ").toUpperCase();

        const isSpecifications =
          title === "PRODUCT SPECIFICATIONS" ||
          title === "PRODUCT SPECIFICATION";

        if (isSpecifications) {
          // 이전에 추가한 행만 제거합니다.
          container.querySelectorAll(
            "[data-material-specification], " +
            "[data-variant-specification]"
          ).forEach(element => element.remove());

          const sizeItems = this.getItems(metafields.size);

          if (sizeItems.length > 0) {
            this.renderList(container, sizeItems);
          } else {
            this.formatExistingContent(container);
          }

          const materials = this.getItems(metafields.material);

          if (materials.length > 0) {
            const materialText = materials
              .map(value => value.replace(/\*/g, "").trim())
              .join(" / ");

            this.appendRow(
              container,
              "Material",
              materialText,
              "data-material-specification"
            );
          }

          const fields = [
            ["SKU", eventVariant?.sku ?? variantData.sku],
            ["EAN", eventVariant?.barcode ?? variantData.barcode]
          ];

          fields.forEach(([label, value]) => {
            const text =
              value == null || String(value).trim() === ""
                ? "N/A"
                : String(value);

            this.appendRow(
              container,
              label,
              text,
              "data-variant-specification"
            );
          });

          const rows = Array.from(
            container.querySelectorAll(
              "[data-variant-specification]"
            )
          );

          const target = container.querySelector("ul, ol") || container;
          target.prepend(...rows);

          block.style.display = "";
          return;
        }

        const key = mapping[title];

        // Manufacturer & Safety 등 연결 대상이 아닌 탭은 유지합니다.
        if (!key) return;

        const items = this.getItems(metafields[key]);

        if (items.length === 0) {
          container.replaceChildren();
          block.style.display = "none";
          return;
        }

        this.renderList(container, items);
        block.style.display = "";
      });
    }
  }

  customElements.define(
    "sq-product-accordion",
    SQProductAccordion
  );
}